<template>
  <div class="pushNotificationMessageDashboard">
    <vue-scroll :ops="ops">
      <div class="pushNotificationMessageDashboard__header">
        <div class="pushNotificationMessageDashboard__title">Push notification message</div>
      </div>
      <div class="pushNotificationMessage__intro">
        <div class="pushNotificationMessage__row">
          <div class="pushNotificationMessage__row__title">Type</div>
          <select v-model="pushNotificationMessageData.type" @change="onChange($event)">
            <option value="WHATS_NEW">What's new</option>
            <option value="SUBSCRIPTION_PROMO">Subscription promo</option>
          </select>
        </div>
      </div>
      <div class="pushNotificationMessage__intro">
        <div class="pushNotificationMessage__row">
          <div class="pushNotificationMessage__row__title">Push title</div>
          <textarea v-model="pushNotificationMessageData.pushTitle" />
        </div>
      </div>
      <div class="pushNotificationMessage__header">Push body</div>
      <div class="pushNotificationMessage__news">
        <div class="pushNotificationMessage__row news">
          <textarea v-model="pushNotificationMessageData.pushBody" />
        </div>
      </div>
      <div class="pushNotificationMessage__intro">
        <div class="pushNotificationMessage__row">
          <div class="pushNotificationMessage__row__title">Popup title</div>
          <textarea v-model="pushNotificationMessageData.popupTitle" />
        </div>
      </div>
      <div class="pushNotificationMessage__header">Popup body</div>
      <div class="pushNotificationMessage__news">
        <div class="pushNotificationMessage__row news">
          <textarea v-model="pushNotificationMessageData.popupBody" />
        </div>
      </div>
      <div v-if="saveButtonVisible" class="pushNotificationMessage__row">
        <div class="pushNotificationMessageDashboard__button bottom" @click="savePushNotificationMessage">
          <span class="text">Save</span>
        </div>
      </div>
      <div v-if="sendButtonVisible" class="pushNotificationMessage__row">
        <div class="pushNotificationMessageDashboard__button bottom" @click="showQuestionPopup">
          <span class="text">Send</span>
        </div>
      </div>
      <div class="pushNotificationMessage__row">
        <div class="pushNotificationMessageDashboard__button bottom" @click="close">
          <span class="text">Close</span>
        </div>
      </div>
    </vue-scroll>
    <QuestionPopup
      :name="'QuestionPopupSend'"
      :title="'Notification will be sent.'"
      :text="'Are you sure?'"
      @remove="sendPushNotificationMessage"
    />
  </div>
</template>

<script>
import moment from 'moment'
import './PushNotificationMessage.styl'
import { pushNotificationMessageAPI } from '@/api/pushNotificationMessages'
import QuestionPopup from '@/components/common/modals/QuestionPopup'

export default {
    props: ['mode'],
    name: 'push-notification-message',
    data: () => ({
      loadedPushNotificationMessage: {
        id: null,
        pushTitle: '',
        pushBody: '',
        popupTitle: '',
        popupBody: '',
        status: '',
        type: '',
      },
      pushNotificationMessageData: {
        id: null,
        pushTitle: '',
        pushBody: '',
        popupTitle: '',
        popupBody: '',
        status: '',
        type: '',
      },
      ops: {
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
    }),
    async mounted () {
      if (this.mode === 'edit') {
        await this.loadPushNotificationMessage(this.$route.params.id)
      }
    },
    methods: {
      moment,
      async savePushNotificationMessage () {
        const savePushNotificationMessageResult = await pushNotificationMessageAPI.savePushNotificationMessage(this.pushNotificationMessageData);
        if (savePushNotificationMessageResult.data.isSuccessfull) {
          const message = {
            title: 'Push notification message saved',
          };
          this.$modal.show('ThanksPopup', {message})
          await this.loadPushNotificationMessage(savePushNotificationMessageResult.data.item)
        } else {
          const message = {
            title: 'Failed to save push notification message',
            text: savePushNotificationMessageResult.data.message,
          };
          this.$modal.show('ThanksPopup', {message})
        }
      },
      async sendPushNotificationMessage () {
        const sendPushNotificationMessageResult = await pushNotificationMessageAPI.sendPushNotificationMessage(this.pushNotificationMessageData.id);
        if (sendPushNotificationMessageResult.data.isSuccessfull) {
          const message = {
            title: 'Push notification message sent',
          };
          this.$modal.show('ThanksPopup', {message});
          this.$router.push('/admin/push-notifications')
        } else {
          const message = {
            title: 'Failed to send push notification message',
            text: sendPushNotificationMessageResult.data.message,
          };
          this.$modal.show('ThanksPopup', {message});
        }
      },
      onChange (event) {
        this.pushNotificationMessageData.type = event.target.value;
      },
      async loadPushNotificationMessage (pushNotificationMessageId) {
        try {
          const pushNotificationMessageResult = await pushNotificationMessageAPI.getPushNotificationMessageById(pushNotificationMessageId);

          if (!pushNotificationMessageResult.data.isSuccessfull) {
            console.log(pushNotificationMessageResult.data.message)
          }
          this.loadedPushNotificationMessage = pushNotificationMessageResult.data.item
          console.log(this.sendButtonVisible)
          this.pushNotificationMessageData.id = this.loadedPushNotificationMessage.id;
          this.pushNotificationMessageData.popupBody = this.loadedPushNotificationMessage.popupBody;
          this.pushNotificationMessageData.popupTitle = this.loadedPushNotificationMessage.popupTitle;
          this.pushNotificationMessageData.pushBody = this.loadedPushNotificationMessage.pushBody;
          this.pushNotificationMessageData.pushTitle = this.loadedPushNotificationMessage.pushTitle;
          this.pushNotificationMessageData.status = this.loadedPushNotificationMessage.status;
          this.pushNotificationMessageData.type = this.loadedPushNotificationMessage.type;
        } catch (e) {
          console.log(e);
        }
      },
      showQuestionPopup () {
        this.$modal.show('QuestionPopupSend')
      },
      close () {
        this.$router.push('/admin/push-notifications')
      },
    },
    computed: {
      saveButtonVisible () {
        if (this.pushNotificationMessageData.popupBody && this.pushNotificationMessageData.popupTitle &&
          this.pushNotificationMessageData.pushTitle && this.pushNotificationMessageData.pushBody &&
          this.pushNotificationMessageData.type && (
          this.loadedPushNotificationMessage.popupBody !== this.pushNotificationMessageData.popupBody ||
          this.loadedPushNotificationMessage.popupTitle !== this.pushNotificationMessageData.popupTitle ||
          this.loadedPushNotificationMessage.pushTitle !== this.pushNotificationMessageData.pushTitle ||
          this.loadedPushNotificationMessage.pushBody !== this.pushNotificationMessageData.pushBody ||
          this.loadedPushNotificationMessage.type !== this.pushNotificationMessageData.type)
        ) {
          return true;
        }
        return false;
      },
      sendButtonVisible () {
        return !this.saveButtonVisible && this.loadedPushNotificationMessage.id
      },
    },
    components: {
      QuestionPopup,
    },
}
</script>
